import "core-js/modules/es.error.cause.js";
import { MARKLIST, MENULIST, TYPELIST, ROLELIST, SOURCE, SOURCE2 } from './utils';
import { panelDetail, addPanel, editPanel } from './request';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    isEdit: {
      type: [Boolean, Number, String],
      default: false,
      required: true
    }
  },
  watch: {
    visible(newV) {
      if (newV && this.$props.isEdit) {
        this.getDetail();
      } else {
        this.formData = {
          dictionariesConfig: 'NO',
          role: undefined,
          mark: undefined,
          sources: undefined,
          type: undefined
        };
        this.dictionariesState = false;
        this.continueState = false;
      }
    },
    // formData() {
    //   console.log(222);
    //   this.timer1 = new Date().getTime();
    // },
    deep: true
  },
  data() {
    return {
      continueState: false,
      dictionariesState: false,
      timer1: '',
      formData: {
        dictionariesConfig: 'NO',
        mark: undefined,
        role: undefined,
        sources: undefined,
        type: undefined
      },
      MARKLIST,
      MENULIST,
      TYPELIST,
      ROLELIST,
      SOURCE,
      SOURCE2,
      SOURCELIST: []
    };
  },
  computed: {
    formFules() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('面板名称'),
          trigger: 'blur'
        }, {
          message: this.$t('1-50字符'),
          max: 50,
          min: 1
        }],
        mark: [{
          required: true,
          validator: this.validateClaimsDocument,
          trigger: 'blur'
        }],
        menu: [{
          required: true,
          message: this.$t('请选择') + this.$t('菜单'),
          trigger: 'change'
        }],
        type: [{
          required: true,
          message: this.$t('请选择') + this.$t('面板分类'),
          trigger: 'change'
        }],
        role: [{
          required: true,
          message: this.$t('请选择') + this.$t('使用角色'),
          trigger: 'change'
        }],
        sources: [{
          required: true,
          message: this.$t('请选择') + this.$t('数据源'),
          trigger: 'change'
        }]
      };
    }
  },
  methods: {
    validateClaimsDocument(rule, value, callback) {
      if (!this.formData.mark && this.formData.dictionariesConfig == 'NO') {
        callback(new Error(this.$t('请选择') + this.$t('标识')));
      } else {
        callback();
      }
    },
    menuChange() {
      console.log(666);
      this.formData.type = undefined;
    },
    closeAddVisible(e) {
      this.$emit('cancel', e);
      this.$refs.dataFormRef.resetFields();
    },
    // 是否继续添加
    onContinueToAdd(e) {
      this.continueState = e.target.checked;
    },
    onDictionariesState(e) {
      this.dictionariesState = e.target.checked;
      this.formData.dictionariesConfig = this.dictionariesState ? 'YES' : 'NO';
      this.formData.mark = undefined;
      this.$refs['dataFormRef'].clearValidate(['mark']);
    },
    async getDetail() {
      this.formData = await panelDetail({
        panelId: this.$props.isEdit
      });
      this.dictionariesState = this.formData.dictionariesConfig == 'YES' ? true : false;
    },
    handleSure() {
      this.$refs.dataFormRef.validate(async valid => {
        if (valid) {
          if (this.$props.isEdit) {
            this.formData.panelId = this.$props.isEdit;
            await editPanel(this.formData);
          } else {
            await addPanel(this.formData);
          }
          this.$message.success(this.$t('操作成功'));
          this.$emit('save');
          // this.$nextTick(() => {

          // });
          if (!this.continueState) {
            this.$emit('cancel');
          }
          this.formData = {
            dictionariesConfig: 'NO',
            mark: undefined,
            role: undefined,
            sources: undefined,
            type: undefined
          };
          this.dictionariesState = false;
          this.$refs.dataFormRef.resetFields();
        }
      });
    },
    sourcesDisabled(val) {
      let status = true;
      if (this.formData.id) {
        this.getSourcesList();
      } else if (val.role && this.formData.mark) {
        status = false;
        this.getSourcesList();
      }
      return status;
    },
    roleChange() {
      this.formData.sources = undefined;
    },
    markChange() {
      this.formData.role = undefined;
    },
    getSourcesList() {
      if (this.formData.role != 'TOTAL_SYSTEM' && this.formData.mark != 'CLAIMS' && this.formData.mark != 'CLAIMS-PEIFUJINE' && this.formData.mark != 'CLAIMS-GUSUNJINE') {
        this.SOURCELIST = this.SOURCE2[this.formData.role];
      } else {
        this.SOURCELIST = this.SOURCE[this.formData.role];
      }
    }
  }
};